/* eslint-disable react-hooks/exhaustive-deps */
import { isNil } from 'ramda';
import { useCallback, useEffect } from 'react';
import { throttle } from '@saturn/utils';

/*
 * @Author: Nanxing Xiang
 * @LastEditors: Nanxing Xiang
 * @Date: 2020-12-18 18:35:10
 * @LastEditTime: 2021-03-17 16:40:43
 * @Description:
 * @FilePath: \easylive-h5\src\hooks\useReachBottom.ts
 */
export default function useReachBottom(fn: () => any, flag?: boolean) {
  const handler = useCallback(
    throttle(() => {
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      const max = scrollHeight - clientHeight;
      if (max - top < 200) fn();
    }, 40),
    [fn]
  );
  useEffect(() => {
    if (isNil(flag)) {
      document.addEventListener('scroll', handler as any, false);
      return () => {
        document.removeEventListener('scroll', handler as any, false);
      };
    }
    if (flag) {
      document.addEventListener('scroll', handler as any, false);
      return () => {
        document.removeEventListener('scroll', handler as any, false);
      };
    }
    return () => {};
  }, [flag, handler]);
}
